import React from 'react';
import logo from '../logo.png';

function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="site-footer">
            <div className="dt-container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <img src={logo} alt="Dark Transport" />
                        <strong>DARK TRANSPORT</strong>
                        <p>The secure-payload layer underneath every channel. SendGrid for secrets.</p>
                    </div>
                    <div className="footer-col">
                        <p className="footer-heading">Product</p>
                        <ul>
                            <li><a href="#problem">The problem</a></li>
                            <li><a href="#features">Features</a></li>
                            <li><a href="#how-it-works">How it works</a></li>
                            <li><a href="#tiers">Tiers</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <p className="footer-heading">Developers</p>
                        <ul>
                            <li><a href="/apidocs">API reference</a></li>
                            <li><a href="/apidocs#authentication">Authentication</a></li>
                            <li><a href="/apidocs#webhooks">Webhooks</a></li>
                            <li><a href="/auth/">Sign in</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <p className="footer-heading">Company</p>
                        <ul>
                            <li><a href="/security">Security</a></li>
                            <li><a href="/contact">Contact</a></li>
                            <li><a href="#notify">Beta access</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <p className="footer-heading">Built by</p>
                        <ul>
                            <li>
                                <a href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">
                                    Andrew Schwabe
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <span>&copy; {year} Dark Transport &middot; Private beta</span>
                    <a href="https://darktransport.com">darktransport.com</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
